import React from "react";
import "./industry.css";
import Project from "./project.js";

import optum_gdb from "./projects/industry/optum_graphdb.png";

import margaret from "./projects/margaret/margaret.png";

import tybalt from "./projects/industry/tybalt.png";


export default function Industry() {
  return (
    <div className="industry_container">
      <h1><b>Industry Projects</b></h1>
      <Project image={margaret} info = {'https://resume-website-mds.s3.amazonaws.com/projects/margaret/margaret_info.md'}/>
      <Project image={tybalt} info={'https://resume-website-mds.s3.amazonaws.com/projects/industry/tybalt_info.md'}/>
      <Project image={optum_gdb} info={'https://resume-website-mds.s3.amazonaws.com/projects/industry/optum_graphdb_info.md'}/>
    </div>
  )
}
